<template>
  <div class="row mt-5 mobile-margin-top">
    <div class="col-lg-12">
      <div class="px-5 py-4 padding-px">
        <form class="px-5 padding-px">
          <div class="form-group d-flex align-items-center row">
            <label
              for
              class="col-sm-2 col-form-label justify-start"
            >{{ trans("account.current_password") }}</label>
            <div class="col-sm-10">
              <input
                v-model="password.current"
                type="password"
                class="form-control bg-gray border-0"
              />
            </div>
          </div>
          <div class="form-group d-flex align-items-center row">
            <label
              for
              class="col-sm-2 col-form-label justify-start"
            >{{ trans("account.new_password") }}</label>
            <div class="col-sm-10">
              <input v-model="password.new" type="password" class="form-control bg-gray border-0" />
            </div>
          </div>
          <div class="form-group d-flex align-items-center row">
            <label
              for
              class="col-sm-2 col-form-label justify-start"
            >{{ trans("account.confirm_password") }}</label>
            <div class="col-sm-10">
              <input
                v-model="password.confirm"
                type="password"
                class="form-control bg-gray border-0"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12 d-flex justify-content-end">
              <button
                @click="handleOk"
                type="button"
                class="btn btn-primary btn-block-mobile px-5"
              >{{ trans("account.update_password") }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return this.initData();
  },
  methods: {
    initData() {
      return {
        password: {
          current: "",
          new: "",
          confirm: ""
        }
      };
    },
    handleOk() {
      if (this.password.new === this.password.confirm) {
        this.submit_update();
      } else {
        alert("error");
      }
    },
    async submit_update() {
      console.log("submit");
      let loader = this.$loading.show();
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //     loader.hide();
      // } else {
      try {
        const { data } = await axios.post(route("api.updatePassword"), {
          password: this.password
        });
        loader.hide();
        this.password = this.initData().password;
        this.successSwal();
      } catch (e) {
        // console.log(e);
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
      // }
    }
  }
};
</script>
